import { useTheme } from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import StyledSvg from '@sdk/components/ui/StyledSvg';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import type { ShiftWithLocationTimezone } from '@web/timeClock/ClockOutModal/clockOutModal.types';
import TimeIconSvg from '@web/assets/svg/Icons/32/time-gray.svg';
import HistoryHeaderButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalHeader/HistoryHeaderButton';
import CloseHeaderButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalHeader/CloseHeaderButton';
import {
  Header,
  HeaderButtons,
  HeaderTextContent,
} from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalHeader/timesheetViewModalHeader.styles';

type Props = {
  onClose: () => void;
  toggleHistory: () => void;
  isHistoryView: boolean;
  shift: ShiftWithLocationTimezone;
  showHistoryButton: boolean;
  themeColor?: ThemeColorType;
};
const TimesheetViewModalHeader = ({
  shift,
  onClose,
  toggleHistory,
  isHistoryView,
  showHistoryButton,
  themeColor = ThemeColorType.primary,
}: Props) => {
  const theme = useTheme();
  const fullname = shift?.user?.fullname;

  return (
    <Header>
      <Row alignItems="center">
        <StyledSvg svg={TimeIconSvg} color={theme.colors[themeColor]} />
        <Row mLeft={12}>
          {Boolean(fullname?.length) && (
            <HeaderTextContent themeColor={themeColor} semiBold fontSize={18} lineHeight={24}>
              {isHistoryView
                ? gettext('Timesheet history')
                : gettext('Timesheet · %(fullname)s', { fullname })}
            </HeaderTextContent>
          )}
        </Row>
      </Row>
      <HeaderButtons>
        {showHistoryButton && (
          <HistoryHeaderButton onClick={toggleHistory} isHistoryView={isHistoryView} />
        )}
        <CloseHeaderButton onClick={onClose} />
      </HeaderButtons>
    </Header>
  );
};

export default TimesheetViewModalHeader;
